import { render, staticRenderFns } from "./ScrollTest.vue?vue&type=template&id=16060cae&scoped=true&"
import script from "./ScrollTest.vue?vue&type=script&lang=js&"
export * from "./ScrollTest.vue?vue&type=script&lang=js&"
import style0 from "./ScrollTest.vue?vue&type=style&index=0&id=16060cae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16060cae",
  null
  
)

export default component.exports